export const CONN = {
  live: { label: "Connected · live data", cls: "bg-emerald-100 text-emerald-700" },
  connected_no_activity: { label: "Connected · zero verified activity", cls: "bg-slate-100 text-slate-600" },
  stale: { label: "Connected · data stale", cls: "bg-amber-100 text-amber-700" },
  error: { label: "Connection error", cls: "bg-red-100 text-red-700" },
  not_connected: { label: "Not connected", cls: "bg-gray-100 text-gray-500" },
  unavailable: { label: "Data unavailable", cls: "bg-gray-100 text-gray-400" },
};

export const HEALTH = {
  up: { label: "Reachable", cls: "text-emerald-600" },
  down: { label: "Unreachable", cls: "text-red-600" },
  misconfigured: { label: "URL not found (check OS URL)", cls: "text-amber-600" },
  not_configured: { label: "No OS configured", cls: "text-gray-400" },
};

export const ConnectionBadge = ({ status, testId }) => {
  const c = CONN[status] || CONN.unavailable;
  return (
    <span className={`rounded-full px-2.5 py-0.5 text-[11px] whitespace-nowrap ${c.cls}`} data-testid={testId}>
      {c.label}
    </span>
  );
};
